import FacilityInfoProvider from '@PROJECT_ROOT/assets/desktop/js/search/mapsearch/FacilityInfoProvider';

export default function showFacilityDetails(
    facilityDetailsUrl,
    $detailsContainer,
    filterFormParameters,
    { marker, facilityId, doubleFacilities },
) {
    const facilityInfoProvider = new FacilityInfoProvider(facilityDetailsUrl, $);
    const parameters = { facilityId, doubleFacilities, filterFormParameters };
    const detailsAsync = getFacilityDetailsAsync(facilityInfoProvider, parameters);

    detailsAsync.then((details) => {
        displayDetails(marker, $detailsContainer, details);
    });

    onMapContainerCloseClick(marker, $detailsContainer);
}

function getFacilityDetailsAsync(facilityInfoProvider, parameters) {
    return facilityInfoProvider.getFacilityDetailsAsync(parameters);
}

function displayDetails(marker, $detailsContainer, details) {
    $detailsContainer.empty();
    $detailsContainer
        .append(details)
        .find('.tooltip')
        .tooltip({
            track: true,
            position: { my: 'left+20 top+10', at: 'right bottom', collision: 'flipfit' },
        });

    // Ako je otvorena kartica drugog objekta potrebno je čekati 400 ms da se izvrši animacija zatvaranja kartice
    // prije prikazivanje nove
    if ($detailsContainer.css('display') === 'none') {
        $detailsContainer.show();
    } else {
        setTimeout(() => { $detailsContainer.show(); }, 400);
    }

    addMapCardClickAwayListener(marker, $detailsContainer);
}

function addMapCardClickAwayListener(marker, $detailsContainer) {
    function mapCardClickAwayListener(facilityMarker, $facilityDetailsContainer, event) {
        const mapCard = $facilityDetailsContainer[0];

        if (!mapCard.contains(event.target)) {
            removeMapCardClickAwayListener();
            closeDetails(facilityMarker, $facilityDetailsContainer);
        }
    }

    const listener = mapCardClickAwayListener.bind(null, marker, $detailsContainer);

    function removeMapCardClickAwayListener() {
        document.removeEventListener('click', listener);
    }

    document.addEventListener('click', listener);
}

function closeDetails(marker, $detailsContainer) {
    marker.removeHighlight();
    $detailsContainer.slideUp(300);
}

function onMapContainerCloseClick(marker, $detailsContainer) {
    $detailsContainer.on('click', '.gClose', () => {
        closeDetails(marker, $detailsContainer);
    });
}
